<template>
  <div class="user-role">
    <div class="controls">
      <div class="add">
        <el-button
          v-if="$hasPermission('userRoleCreate')"
          type="success"
          icon="el-icon-plus"
          circle
          @click="$router.push({ name: 'userRolesAdd' })"
        />
      </div>
      <div class="search">
        <el-input
          v-model="username"
          clearable
          placeholder="请输入用户名"
          @keyup.enter.native="
            $router.replace({ query: { username: username } })
          "
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
          />
        </el-input>
      </div>

      <div class="clearfix" />
    </div>

    <div class="roles-list">
      <div v-if="userRoles">
        <el-table
          :data="userRoles"
          style="width: 100%; margin-top: 20px;"
        >
          <el-table-column
            prop="username"
            label="用户名"
            min-width="150"
          />
          <el-table-column
            label="角色"
            min-width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.roles | mergeRoles }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="$hasPermission('userRoleEdit')"
                size="small"
                type="text"
                @click="
                  $router.push({
                    name: 'userRolesEdit',
                    params: { username: scope.row.username }
                  })
                "
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div
          class="pager"
          style="margin: 40px 0;"
        >
          <el-pagination
            layout="prev, pager, next"
            :total="total"
            :page-size="limit"
            :current-page="page"
            :background="true"
            @current-change="pageChange"
          />
        </div>
      </div>
      <div
        v-else
        class="none"
      >
        <p>暂无用户角色数据</p>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.none {
  text-align: center;
  line-height: 30px;
  color: #333;
}

.controls {
  margin-bottom: 10px;
  .add {
    float: left;
  }

  .search {
    width: 200px;
    float: right;
  }

  clear: both;
}
</style>
<script>
const debug = require('debug')('ccs:ctrl:user-role');
import { defaults } from 'lodash';
import axios from 'axios';

export default {
	filters: {
		mergeRoles(roles) {
			return roles.map(role => role.name).join(',');
		}
	},
	data() {
		return {
			userRoles: [],
			username: '',
			page: 0,
			total: 0,
			limit: 0
		};
	},
	watch: {
		$route: async function() {
			await this.search();
		}
	},

	async created() {
		await this.search();
	},
	methods: {
		async search(query = {}) {
			defaults(query, this.$route.query);
			debug('[search] query: %o', query);

			const { page, pages, limit, total, data } = await axios.get(
				'/api/userRoles',
				{
					params: query
				}
			);

			this.page = page;
			this.total = total;
			this.limit = limit;
			this.userRoles = data;
			this.username = query.username || '';
		},

		pageChange(page) {
			debug('[pageChange] %s', page);
			const query = { page };
			defaults(query, this.$route.query);
			this.$router.replace({ query });
		}
	}
};
</script>